export const getProfileImageUrl = (user?: {
  email?: string | null;
  profilePicUrl?: string | null;
}) => {
  const { profilePicUrl } = user || {};
  return profilePicUrl || "";
};
